import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="#80B8EE"
        fillRule="evenodd"
        d="M19.143 3.071c0-.591-.48-1.071-1.072-1.071h-15C2.48 2 2 2.48 2 3.071v15c0 .592.48 1.072 1.071 1.072h3.215v1.071l.009.183c.091.9.852 1.603 1.776 1.603h12.143l.183-.01A1.786 1.786 0 0 0 22 20.215V6.643l-.01-.183a1.786 1.786 0 0 0-1.776-1.603h-1.071V3.071Zm0 3.215V18.07c0 .592-.48 1.072-1.072 1.072H7.714v1.071c0 .17.118.311.276.348l.081.01h12.143c.17 0 .311-.118.348-.276l.01-.082V6.643c0-.17-.118-.31-.276-.348l-.082-.01h-1.071ZM7 17.714h10.714V3.43H3.43v14.285H7Zm3.571-4.632-2.17 1.03a.307.307 0 0 1-.406-.135.288.288 0 0 1-.024-.191l.484-2.2-1.64-1.578a.29.29 0 0 1-.002-.417.307.307 0 0 1 .17-.085l2.28-.34L10.3 7.164a.308.308 0 0 1 .542 0l1.037 2.004 2.281.34a.292.292 0 0 1 .168.501l-1.64 1.578.484 2.2a.295.295 0 0 1-.233.35.312.312 0 0 1-.197-.023l-2.17-1.031Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>
)
export default SvgComponent
